import { useAgenda } from '../../context/AgendaContext';
import { AgendaItem } from './AgendaItem';
import { Card } from '../UI/Card';
import styles from './AgendaList.module.css';

/**
 * AgendaList Component
 * 
 * Displays the complete event schedule with:
 * - All agenda items sorted chronologically
 * - Vertical timeline connecting items
 * - Fire accent indicator for current position
 * - Responsive layout (list on mobile, grid on desktop)
 * - Active item highlighting
 * 
 * Validates Requirements: 6.1, 6.2, 6.3, 6.4, 6.5, 6.6
 */
export function AgendaList() {
  const { agendaItems, currentItem } = useAgenda();

  // Sort items chronologically by start time
  const sortedItems = [...agendaItems].sort(
    (a, b) => a.startTime.getTime() - b.startTime.getTime()
  );

  // Determine if each item is past, active, or future
  const now = new Date();
  const itemsWithStatus = sortedItems.map(item => ({
    item,
    isActive: currentItem?.id === item.id,
    isPast: now >= item.endTime
  }));

  return (
    <Card className={styles.agendaListCard}>
      <div className={styles.header}>
        <h2 className={styles.title}>Event Schedule</h2>
        <p className={styles.subtitle}>
          {sortedItems.length} {sortedItems.length === 1 ? 'item' : 'items'}
        </p>
      </div>

      <div className={styles.timeline}>
        {itemsWithStatus.map(({ item, isActive, isPast }, index) => (
          <div key={item.id} className={styles.timelineItem}>
            <AgendaItem 
              item={item} 
              isActive={isActive} 
              isPast={isPast}
            />
            {/* Don't render line after last item */}
            {index === itemsWithStatus.length - 1 && (
              <div className={styles.timelineEnd} />
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
